module.exports = __webpack_public_path__ + "img/fond-formes-superposees.5d5eefd3.png";